/**
 * Mobile filter drawer.
 */

function trapFocus(drawer) {
	drawer.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			closeDrawer(drawer);
		}
	});
}

function openDrawer(drawer, trigger) {
	drawer.hidden = false;
	drawer.classList.add('is-open');
	document.body.classList.add('no-scroll');
	trapFocus(drawer);
	drawer.querySelector('[data-filters-close]')?.focus();
	drawer._trigger = trigger;
}

function closeDrawer(drawer) {
	drawer.hidden = true;
	drawer.classList.remove('is-open');
	document.body.classList.remove('no-scroll');
	drawer._trigger?.focus();
}

export function initFilters() {
	const drawer = document.getElementById('dc-filters-drawer');
	const openBtn = document.querySelector('[data-filters-open]');

	if (!drawer) {
		return;
	}

	openBtn?.addEventListener('click', () => openDrawer(drawer, openBtn));

	drawer.querySelectorAll('[data-filters-close]').forEach((btn) => {
		btn.addEventListener('click', () => closeDrawer(drawer));
	});

	const drawerForm = drawer.querySelector('.dc-shop-filters-form');

	drawer.querySelector('[data-filters-apply]')?.addEventListener('click', () => {
		drawerForm?.requestSubmit();
	});

	drawer.querySelector('[data-filters-clear]')?.addEventListener('click', () => {
		const clearUrl = drawerForm?.action || drawer.querySelector('.dc-shop-filters__clear')?.href;
		if (clearUrl) {
			window.location.href = clearUrl;
		}
	});
}
